export const SET_VIDEO = 'PARTNER/VIDEO/SET_VIDEO'
export const SET_VIDEOS = 'PARTNER/VIDEO/SET_VIDEOS'
